import { render, staticRenderFns } from "./employ_tips.vue?vue&type=template&id=4fc0d7b7&scoped=true&"
import script from "./employ_tips.vue?vue&type=script&lang=js&"
export * from "./employ_tips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc0d7b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fc0d7b7')) {
      api.createRecord('4fc0d7b7', component.options)
    } else {
      api.reload('4fc0d7b7', component.options)
    }
    module.hot.accept("./employ_tips.vue?vue&type=template&id=4fc0d7b7&scoped=true&", function () {
      api.rerender('4fc0d7b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/employees/modal/tabs/employ_tips.vue"
export default component.exports